<app-lang-switch position="absolute"></app-lang-switch>
<div class="container flex" [formGroup]="forgotPasswordForm">
  <div class="widget loginFormContainer flex flex-column gap-4 p-6">
    <h2>{{ "auth.forgot_password.title" | translate }}</h2>
    <div class="flex flex-column gap-2 mb-3">
      <label for="username" class="font-semibold">{{ "auth.forgot_password.username" | translate }}</label>
      <input pInputText id="username" formControlName="username" autocomplete="off" (keyup)="onKeyUp($event)" />
    </div>

    <app-button [block]="true" buttonText="auth.forgot_password.reset_button" (click)="forgotPassword()"></app-button>
  </div>
</div>
